import { Grid } from '@tiendanube/components';
import { PlanCardSkeleton } from '../../PlanCard';

function ComparisonPlansCardsDesktopSkeleton(): JSX.Element {
  return (
    <Grid fluid>
      <Grid.Row>
        <Grid.Column>
          <PlanCardSkeleton />
        </Grid.Column>
        <Grid.Column>
          <PlanCardSkeleton />
        </Grid.Column>
        <Grid.Column>
          <PlanCardSkeleton />
        </Grid.Column>
        <Grid.Column>
          <PlanCardSkeleton />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default ComparisonPlansCardsDesktopSkeleton;
